package com.shadowings.gero.presentation.model

enum class RewardedAdStatus {
    LOADING,
    READY,
    UNAVAILABLE,
}
